import { CreatePropertyError } from "./CreatePropertyError";

export default class PropertyRecordAlreadyExistsError extends CreatePropertyError {

}